<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <div class="disclaimer">
        <router-link to="/disclaimer"><b>Disclaimer</b></router-link> - <router-link to="/privacy"><b>Privacy statement</b></router-link> - <router-link to="/complaints"><b>Complaints</b></router-link> <br/>
        Alpha Based Capital Fund Management B.V. is authorised and regulated by the Dutch Authority for the Financial Markets (AFM).<br/>
        Please consider the investment objectives, risks and charges and expenses of the Fund carefully before investing. The Fund's prospectus contains this and other information about the Fund.
      </div>
      <div class="copyright">
        &copy; {{ year }} Alpha Based Capital
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
